import noop from '@gaia/util/noop/action'
import edit from './action/edit'
import menu from './action/menu'
import profile from './action/profile'
import settings from './action/settings'
import submit from './action/submit'
import submitLanguage from './action/submitLanguage'
import verify from './action/verify'

export default {
  profile,
  avatar: noop,
  edit,
  teams: noop,
  change: noop,
  language: noop,
  settings,
  menu,
  submit,
  submitLanguage,
  verify,
  verifyError: noop,
  confirmRemove: noop,
}
